import './Menu.style.scss';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { MenuItem } from 'primereact/menuitem';
import { decrypt } from '../../../utilities/Encriptacion';
import fallbackLogo from '../../../assets/img/logo.png';

const Menu: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [image, setImage] = useState<string | undefined>(undefined);
    const [company, setCompany] = useState<string | undefined>(undefined);

    useEffect(() => {
        const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;
        const data = decrypt(sessionStorage.getItem('dataClient'), CLAVE);
        const parsedData = JSON.parse(data);
        setImage(parsedData.image);
        setCompany(parsedData.initials);
    }, []);

    const items: MenuItem[] = [
        {
            label: 'Mapa',
            icon: 'pi pi-map',
            className: location.pathname === `/${company}/panel` ? 'menu-item-active' : '',
            command: () => navigate(`/${company}/panel`),
        },
        {
            label: 'Itinerario',
            icon: 'pi pi-map-marker',
            className: location.pathname === `/${company}/paradas` ? 'menu-item-active' : '',
            command: () => navigate(`/${company}/paradas`),
        },
        {
            label: 'Contacto',
            icon: 'pi pi-address-book',
            className: location.pathname === `/${company}/contacto` ? 'menu-item-active' : '',
            command: () => navigate(`/${company}/contacto`),
        },
    ];

    const start = (
        <img
            className="menu-logo"
            src={image || fallbackLogo}
            alt="logo"
            onError={(e) => {
                const img = e.currentTarget;
                if (img.dataset.fallback) return;
                img.dataset.fallback = 'true';
                img.src = fallbackLogo;
            }}
        />
    );

    return (
        <Menubar
            className="app-menubar"
            model={items}
            start={start}
        />
    );
};

export default Menu;
